export default [
    {
        path: '/labors',
        name: 'Company / Labors',
        component: () => import('@/views/pages/labors'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'sales',
                name: 'Company / Labors / Sales',
                component: () => import('@/views/pages/labors'),
                meta:
                {
                    page: 'sales',
                },
            },
            {
                path: 'create',
                name: 'Company / Create Labor',
                component: () => import('@/views/pages/labors'),
                meta:
                {
                    page: 'create',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Labor',
                component: () => import('@/views/pages/labors'),
                meta:
                {
                    page: 'view',
                },
                children:
                [
                    {
                        path: 'edit',
                        name: 'Company / Edit Labor',
                        component: () => import('@/views/pages/labors'),
                        meta:
                        {
                            page: 'edit',
                            subPage: 'main',
                        },
                    },
                ],
            },
        ],
    },
];